import {
    getUrlWithoutQueryString,
    buildQueryParameters,
    QueryParameter
} from './common';
import { AjaxDispatcher, ActionCreator } from './ajax-dispatcher';
import { FilterQueryParameter } from './search-filter';

interface Sortable {
    element: Element;
    name: string;
    direction: SortDirection;
}

enum SortDirection {
    Default = 'default',
    Asc = 'Asc',
    Desc = 'Desc'
}

export class SortingList {
    private sortingListElement: Element;
    private sortableColumnElements: Sortable[] = [];
    private onSort: () => void;

    private queryParams: QueryParameter[];
    private filter: FilterQueryParameter;


    constructor(
        sortingListElement: Element,
        onSort: () => void,
        queryParams: QueryParameter[] = [],
        filter: FilterQueryParameter = null
    ) {
        this.sortingListElement = sortingListElement;
        this.onSort = onSort;
        this.queryParams = queryParams;
        this.filter = filter;
        this.initSortableColumnElements();
        this.subscribeSortableColumns();
    }

    private initSortableColumnElements(): void {
        const sortableColumnElements = Array.from(
            this.sortingListElement.querySelectorAll('[data-sortable]')
        );
        sortableColumnElements.forEach(e => {
            const directionState = e.getAttribute('data-sort-direction');
            const direction: SortDirection = SortDirection[directionState];

            this.sortableColumnElements.push({
                element: e,
                name: e.getAttribute('data-sortable'),
                direction
            });
        });
    }

    private subscribeSortableColumns(): void {
        this.sortableColumnElements.forEach(i => {
            i.element.addEventListener('click', () => this.sort(i));
        });
    }

    private createQueryParameters(column: Sortable): QueryParameter[] {
        const newDirection = this.resolveSortDirection(column.direction);
        const queryParameters = [
            ...this.queryParams,
            ...this.filter.getFilterQueryParameters(),
            { key: 'sort-by', value: column.name },
            { key: 'sort-direction', value: newDirection.toString() }
        ];

        return queryParameters;
    }

    private resolveSortDirection(direction: SortDirection): SortDirection {
        switch (direction) {
            case SortDirection.Desc:
                return SortDirection.Asc;
            case SortDirection.Asc:
                return SortDirection.Desc;
            case SortDirection.Default:
                return SortDirection.Asc;
        }
    }

    private sort(column: Sortable): void {
        const componentName = this.sortingListElement.getAttribute(
            'data-component'
        );
        const queryParameters = this.createQueryParameters(column);
        this.refreshUrl(queryParameters);

        const action = new ActionCreator().reloadComponent(componentName);
        action.successAction = this.onSort;

        new AjaxDispatcher().dispatchGetAction(action);
    }

    private refreshUrl(queryParameters: QueryParameter[]): void {
        const queryString = buildQueryParameters(queryParameters);
        const url = queryString
            ? getUrlWithoutQueryString() + '?' + queryString
            : getUrlWithoutQueryString();

        const newUrlState = { title: document.title, url: url };
        window.history.pushState(newUrlState, document.title, url);
    }
}
